if (!customElements.get('collection-showcase')) {
  customElements.define(
    'collection-showcase',
    class CollectionShowcase extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('.collection-showcase__tab'));
        this.panels = Array.from(this.querySelectorAll('.collection-showcase__panel'));
        this.tabsTrack = this.querySelector('.collection-showcase__tabs');
        this.prevArrow = this.querySelector('.collection-showcase__arrow--prev');
        this.nextArrow = this.querySelector('.collection-showcase__arrow--next');
        this.scrollThreshold = 200;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });

        this.panels.forEach((panel) => {
          const scroller = panel.querySelector('.collection-showcase__panel-scroll');
          if (!scroller) return;
          scroller.addEventListener('scroll', () => this.onPanelScroll(panel, scroller));
        });

        if (this.prevArrow) this.prevArrow.addEventListener('click', () => this.scrollTabs(-1));
        if (this.nextArrow) this.nextArrow.addEventListener('click', () => this.scrollTabs(1));

        this.updateArrows();
        if (this.tabsTrack) this.tabsTrack.addEventListener('scroll', () => this.updateArrows());

        if (this.tabs.length > 0) this.selectTab(0);
      }

      selectTab(index) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
        const activeTab = this.tabs[index];
        if (activeTab) activeTab.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }

      onTabKeydown(event, index) {
        let newIndex = null;
        if (event.key === 'ArrowRight') newIndex = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') newIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') newIndex = 0;
        else if (event.key === 'End') newIndex = this.tabs.length - 1;
        else return;

        event.preventDefault();
        this.selectTab(newIndex);
        this.tabs[newIndex].focus();
      }

      scrollTabs(direction) {
        if (!this.tabsTrack) return;
        const amount = this.tabsTrack.clientWidth * 0.8 * direction;
        this.tabsTrack.scrollBy({ left: amount, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.tabsTrack || !this.prevArrow || !this.nextArrow) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.tabsTrack;
        this.prevArrow.classList.toggle('collection-showcase__arrow--disabled', scrollLeft <= 1);
        this.nextArrow.classList.toggle(
          'collection-showcase__arrow--disabled',
          scrollLeft + clientWidth >= scrollWidth - 1,
        );
      }

      onPanelScroll(panel, scroller) {
        if (panel.hidden) return;
        if (panel.dataset.loading === 'true' || panel.dataset.hasNext !== 'true') return;

        const distanceFromBottom = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
        if (distanceFromBottom > this.scrollThreshold) return;

        this.loadNextPage(panel, scroller);
      }

      loadNextPage(panel, scroller) {
        const collectionUrl = panel.dataset.collectionUrl;
        const nextPage = panel.dataset.nextPage;
        if (!collectionUrl || !nextPage) return;

        panel.dataset.loading = 'true';
        const spinner = panel.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const url = `${collectionUrl}?view=showcase-grid&page=${nextPage}`;

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`Failed to load products: ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newItems = doc.querySelectorAll('.grid__item');
            const meta = doc.querySelector('[data-showcase-meta]');
            const list = scroller.querySelector('.grid');

            if (list && newItems.length > 0) {
              newItems.forEach((item) => list.appendChild(item));
            }

            const hasNext = meta ? meta.dataset.hasNext === 'true' : false;
            panel.dataset.hasNext = hasNext ? 'true' : 'false';
            panel.dataset.nextPage = String(Number(nextPage) + 1);
          })
          .catch((error) => {
            console.error(error);
            panel.dataset.hasNext = 'false';
          })
          .finally(() => {
            panel.dataset.loading = 'false';
            if (spinner) spinner.classList.add('hidden');
          });
      }
    },
  );
}
